const ProjectsData = [
    {
        imgsrc: "https://cdn.analyticsvidhya.com/wp-content/uploads/2020/12/1dZR-6mVLWHoQr7vBIU2-kw.png",
        title: "Stack Overflow",
        description: "loremipsumeskjchdbclkamcjkasbckaca",
        view: "https://strong-taiyaki-dc8873.netlify.app/",
        frontendsource: "https://github.com/Seetharaman96/stackoverflow-frontend",
        backendsource: "https://github.com/Seetharaman96/Stackoverflow-Backend",
    },
    {
        imgsrc: "https://img.freepik.com/free-photo/movie-background-collage_23-2149876028.jpg",
        title: "Movies App",
        description: "loremipsumeskjchdbclkamcjkasbckaca",
        view: "https://vocal-croquembouche-2f5a6c.netlify.app/",
        frontendsource: "https://github.com/Seetharaman96/React-App",
        backendsource: "https://github.com/Seetharaman96/MongoDB",
    },
    {
        imgsrc: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        title: "Customer Relationship Management",
        description: "loremipsumeskjchdbclkamcjkasbckaca",
        view: "https://neon-jelly-15a80e.netlify.app/",
        frontendsource: "https://github.com/Seetharaman96/crm-frontend",
        backendsource: "https://github.com/Seetharaman96/CRM-Backend",
    },
    {
        imgsrc: "https://images.unsplash.com/photo-1557821552-17105176677c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1032&q=80",
        title: "Add to Cart(Front-end application)",
        description: "A Front-End application used for add to cart and remove from cart",
        view: "https://fascinating-druid-3708a8.netlify.app/",
        frontendsource: "https://github.com/Seetharaman96/react-add-to-cart",
    },
    {
        imgsrc: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bGlicmFyeSUyMHdlYnNpdGV8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60",
        title: "Library Management(Front-end application)",
        description: "loremipsumeskjchdbclkamcjkasbckaca",
        view: "https://adorable-longma-4c40be.netlify.app/",
        frontendsource: "https://github.com/Seetharaman96/react-library-management-crud",
    },
    // {
    //     imgsrc: "https://images.unsplash.com/photo-1577896851231-70ef18881754?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    //     title: "Student Teacher Management",
    //     description: "loremipsumeskjchdbclkamcjkasbckaca",
    //     view: "https://snazzy-concha-6bf89f.netlify.app/",
    //     frontendsource: "https://github.com/Seetharaman96/react-teacher-student",
    // },
    {
        imgsrc: "https://plus.unsplash.com/premium_photo-1661306523308-d37fc69771b4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=869&q=80",
        title: "Hall Booking(Back-end application)",
        description: "loremipsumeskjchdbclkamcjkasbckaca",
        view: "https://hall-booking-nodejs-task2.onrender.com/",
        backendsource: "https://github.com/Seetharaman96/Hall-Booking-node-task-2",
    },
];

export default ProjectsData;